// src/components/DynamicReportInputs/PeriodSelector.js
import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import DateField from "./PeriodField";

const useStyles = makeStyles((theme) => ({
  textField: {
    minWidth: 250,
    width: "100%",
  },
}));

export default function PeriodSelector({ 
  value, 
  onChange, 
  label = "Período", 
  error = null, 
  required = false 
}) {
  const classes = useStyles();

  // string "YYYYMMDD" -> DateField
  const selectedDate = useMemo(() => {
    if (value && String(value).length === 8) {
      const year = parseInt(String(value).substring(0, 4), 10);
      const month = parseInt(String(value).substring(4, 6), 10) - 1;
      const day = parseInt(String(value).substring(6, 8), 10);
      return new Date(year, month, day);
    }
    return null;
  }, [value]);

  // DateField -> string "YYYYMMDD"
  const handleDateChange = (date) => {
    if (date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      onChange(`${year}${month}${day}`);
    } else {
      onChange("");
    }
  };

  return (
    <DateField
      label={label}
      value={selectedDate}
      onChange={handleDateChange}
      views={["year", "month", "date"]}
      format="dd/MM/yyyy"
      fieldClassName={classes.textField}
      error={!!error}
      helperText={error}
      required={required}
      clearable={true}
      placeholder={label}
    />
  );
}